<vb-ui-toggle-content-display [minItems]="5" [totalItems]="customFields.length">
	<div #vbUiToggleItem *ngFor="let field of customFields" layout="row" [ngClass]="styles.wrapper">
		<span [ngClass]="styles.key"> {{field.name}} </span>
		<span [ngClass]="styles.value"> {{field.value}} </span>
	</div>
</vb-ui-toggle-content-display>
